(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this._publishHeight();
      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(() => this._publishHeight());
        this._ro.observe(this);
      }

      this.items = Array.from(this.querySelectorAll('.announcement-bar__track > *'));
      if (this.items.length < 2) return;

      this.interval = Number(this.dataset.interval) || 5000;
      this.index = 0;
      this.items[0].classList.add('is-active');

      this._timer = setInterval(() => this._next(), this.interval);
    }

    _publishHeight() {
      // A transparent header positions itself below this bar. The height
      // depends on font size and wrapping, so it has to be measured rather
      // than assumed.
      const h = Math.round(this.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }

    disconnectedCallback() {
      clearInterval(this._timer);
      if (this._ro) this._ro.disconnect();
      document.documentElement.style.removeProperty('--announcement-height');
    }

    _next() {
      this.items[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.items.length;
      this.items[this.index].classList.add('is-active');
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ardent-bundle-product"]) return;
  try {
    
  // One piece of state — `view` ∈ { 'bundle', '0', '1', ... } — shared by
  // TWO controls: the gallery thumbnails (data-bundle-select) and the
  // Explore the Set tabs (data-bundle-tab). Both write to the exact same
  // `select()` call, so there is never a "thumbnail says X, tab says Y"
  // desync — see the class-level select() method below.
  class ArdentBundleHero extends HTMLElement {
    connectedCallback() {
      this.view = 'bundle';

      this._onClick = this._onClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._onSubmit = this._onSubmit.bind(this);

      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeydown);

      this.form = this.querySelector('form');
      if (this.form) this.form.addEventListener('submit', this._onSubmit);

      // Desktop keeps tasting notes under the gallery thumbnails, matching
      // the Premium PDP; mobile instead reads it between the spec grid and
      // the description, same reasoning and technique as
      // ardent-product.liquid's own _layoutTastingNotes(): the two columns
      // flow independently, so this moves the one real DOM node for the
      // breakpoint rather than duplicating it or fighting layout with grid
      // placement. Matches the bundle grid's own 900px collapse point.
      this._mobileQuery = window.matchMedia('(max-width: 899px)');
      this._onLayoutChange = this._layoutTastingNotes.bind(this);
      this._mobileQuery.addEventListener('change', this._onLayoutChange);
      this._layoutTastingNotes();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKeydown);
      if (this.form) this.form.removeEventListener('submit', this._onSubmit);
      if (this._mobileQuery) this._mobileQuery.removeEventListener('change', this._onLayoutChange);
      clearTimeout(this._resetTimer);
    }

    _layoutTastingNotes() {
      const tasting = this.querySelector('[data-bundle-tasting]');
      if (!tasting) return;

      if (this._mobileQuery.matches) {
        const anchor = this.querySelector('[data-bundle-specs-prompt]');
        if (anchor && tasting.previousElementSibling !== anchor) {
          anchor.insertAdjacentElement('afterend', tasting);
        }
      } else {
        const mediaCol = this.querySelector('.ardent-bundle__media-col');
        if (mediaCol && tasting.parentElement !== mediaCol) {
          mediaCol.appendChild(tasting);
        }
      }
    }

    get tabs() {
      return [...this.querySelectorAll('[data-bundle-tab]')];
    }

    _onClick(event) {
      const control = event.target.closest('[data-bundle-select], [data-bundle-tab]');
      if (control) {
        const view = control.dataset.bundleSelect ?? control.dataset.bundleTab;
        this.select(view);
        return;
      }

      const trigger = event.target.closest('[data-bundle-accordion-trigger]');
      if (trigger) this._toggleAccordion(trigger);
    }

    // Arrow-key navigation across the bottle tablist.
    _onKeydown(event) {
      const tab = event.target.closest('[data-bundle-tab]');
      if (!tab) return;

      const keys = { ArrowLeft: -1, ArrowRight: 1 };
      const step = keys[event.key];
      if (!step) return;

      event.preventDefault();
      const tabs = this.tabs;
      const index = tabs.indexOf(tab);
      const next = tabs[(index + step + tabs.length) % tabs.length];
      if (!next) return;

      this.select(next.dataset.bundleTab);
      next.focus();
    }

    select(view) {
      this.view = view;
      // The bundle itself is now a real explorer state — 'bundle' — with
      // no per-bottle fallback. Every bottle-only panel (tasting notes,
      // description, specs) matches the raw `view` directly and simply
      // has nothing to show while 'bundle' is active.
      const isBundle = view === 'bundle';

      this.querySelectorAll('[data-bundle-image]').forEach((el) => {
        el.hidden = el.dataset.bundleImage !== view;
      });

      this.querySelectorAll('[data-bundle-select]').forEach((el) => {
        const on = el.dataset.bundleSelect === view;
        el.classList.toggle('is-selected', on);
        el.setAttribute('aria-pressed', String(on));
      });

      this.tabs.forEach((el) => {
        const on = el.dataset.bundleTab === view;
        el.classList.toggle('is-selected', on);
        el.setAttribute('aria-selected', String(on));
        el.tabIndex = on ? 0 : -1;
      });

      // Tasting notes have no bundle-level content at all — hide the whole
      // card, including its background/padding, not just the text. Same
      // treatment if the selected bottle simply has no tasting metafields
      // filled in yet: an empty muted card is worse than no card.
      this.querySelectorAll('[data-bundle-panel]').forEach((el) => {
        el.hidden = el.dataset.bundlePanel !== view;
      });
      const tasting = this.querySelector('[data-bundle-tasting]');
      if (tasting) {
        const hasTastingContent = !!tasting.querySelector(`[data-bundle-panel="${view}"]`);
        tasting.hidden = isBundle || !hasTastingContent;
      }

      this.querySelectorAll('[data-bundle-specs-panel]').forEach((el) => {
        el.hidden = isBundle || el.dataset.bundleSpecsPanel !== view;
      });
      const prompt = this.querySelector('[data-bundle-specs-prompt]');
      if (prompt) prompt.hidden = !isBundle;

      // Description lives inside the shared accordion group (alongside
      // Shipping/Returns) so its presentation matches the Premium PDP's
      // own default-open description item. Switching the explorer state
      // is effectively "now looking at different content", so it resets
      // the whole group back to its default: the newly-active state's own
      // description open, everything else (including Shipping/Returns)
      // collapsed — otherwise an earlier Shipping click would leave every
      // subsequently-selected bottle's description stuck closed.
      this.querySelectorAll('[data-bundle-accordion-trigger]').forEach((el) => {
        el.setAttribute('aria-expanded', 'false');
        const panel = el.nextElementSibling;
        if (panel) panel.hidden = true;
      });
      const activeDescription = this.querySelector(`.ardent-bundle__accordion-item[data-bundle-panel="${view}"] [data-bundle-accordion-trigger]`);
      if (activeDescription) {
        activeDescription.setAttribute('aria-expanded', 'true');
        const panel = activeDescription.nextElementSibling;
        if (panel) panel.hidden = false;
      }
    }

    _toggleAccordion(trigger) {
      const open = trigger.getAttribute('aria-expanded') === 'true';
      // Exactly one open at a time.
      this.querySelectorAll('[data-bundle-accordion-trigger]').forEach((el) => {
        el.setAttribute('aria-expanded', 'false');
        const panel = el.nextElementSibling;
        if (panel) panel.hidden = true;
      });

      if (!open) {
        trigger.setAttribute('aria-expanded', 'true');
        const panel = trigger.nextElementSibling;
        if (panel) panel.hidden = false;
      }
    }

    // Same convention as every other add-to-cart in the theme: POST the
    // form, then dispatch a bubbling `cart:add` — sections/cart-drawer.liquid
    // listens globally and handles opening/refreshing itself.
    async _onSubmit(event) {
      event.preventDefault();

      // Plural: the sticky add-to-cart bar (if enabled) carries its own
      // copy of this same button, so a submit triggered from either one
      // disables and relabels both together.
      const buttons = this.querySelectorAll('[data-bundle-add]');
      const errorEl = this.querySelector('[data-bundle-error]');
      if (!buttons.length || buttons[0].disabled) return;

      clearTimeout(this._resetTimer);
      if (errorEl) errorEl.hidden = true;
      buttons.forEach((button) => {
        button.disabled = true;
        button.textContent = button.dataset.addingText;
      });

      let failed = false;
      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Add to cart failed');

        buttons.forEach((button) => {
          button.textContent = button.dataset.addedText;
        });
        this.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { item: data } }));
      } catch (error) {
        failed = true;
        if (errorEl) {
          errorEl.textContent = error.message;
          errorEl.hidden = false;
        }
      } finally {
        this._resetTimer = setTimeout(
          () => {
            buttons.forEach((button) => {
              button.disabled = false;
              button.textContent = button.dataset.idleText;
            });
          },
          failed ? 0 : 1800
        );
      }
    }
  }

  if (!customElements.get('ardent-bundle-hero')) {
    customElements.define('ardent-bundle-hero', ArdentBundleHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ardent-faq"] && !Shopify.designMode) return;
  try {
    
  class ArdentFaq extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    _onClick(event) {
      const trigger = event.target.closest('[data-ardent-faq-trigger]');
      if (!trigger) return;

      const item = trigger.closest('[data-ardent-faq-item]');
      const panel = item.querySelector('.ardent-faq-item__panel');
      const isOpen = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', String(isOpen));
      panel.hidden = !isOpen;
    }
  }

  if (!customElements.get('ardent-faq')) {
    customElements.define('ardent-faq', ArdentFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ardent-product"] && !Shopify.designMode) return;
  try {
    
  class ArdentGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-ardent-gallery-main]');
      this.slides = [...this.querySelectorAll('[data-ardent-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-ardent-thumb]')];
      this.thumbsStrip = this.querySelector('[data-ardent-gallery-thumbs]');
      const initialSlide = this.slides.find((s) => s.classList.contains('is-active')) || this.slides[0];
      this._activeMediaId = initialSlide ? initialSlide.dataset.mediaId : null;

      this._onThumbClick = this._onThumbClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._onMainScroll = this._onMainScroll.bind(this);
      this._pauseAutoplay = this._pauseAutoplay.bind(this);
      this._resumeAutoplay = this._resumeAutoplay.bind(this);

      this.thumbs.forEach((thumb) => thumb.addEventListener('click', this._onThumbClick));
      if (this.main) {
        this.main.addEventListener('keydown', this._onKeydown);
        // Swiping/scrolling the gallery directly (touch, trackpad, native
        // scroll-snap) never goes through showMedia(), so without this the
        // thumbnail strip silently desyncs from whatever is actually on
        // screen. `scrollend` (where supported) fires once per gesture,
        // after snap has settled; the debounced `scroll` fallback covers
        // browsers without it (older Safari).
        if ('onscrollend' in window) {
          this.main.addEventListener('scrollend', () => this._syncActiveFromScroll());
        } else {
          this.main.addEventListener('scroll', this._onMainScroll, { passive: true });
        }
      }

      this._setUpAutoplay();
    }

    disconnectedCallback() {
      this.thumbs.forEach((thumb) => thumb.removeEventListener('click', this._onThumbClick));
      if (this.main) {
        this.main.removeEventListener('keydown', this._onKeydown);
        this.main.removeEventListener('scroll', this._onMainScroll);
      }
      clearTimeout(this._scrollSyncTimer);
      this._stopAutoplay();
      if (this._pauseOnHover) {
        this.removeEventListener('mouseenter', this._pauseAutoplay);
        this.removeEventListener('mouseleave', this._resumeAutoplay);
        this.removeEventListener('focusin', this._pauseAutoplay);
        this.removeEventListener('focusout', this._resumeAutoplay);
      }
    }

    _setUpAutoplay() {
      const autoplay = this.dataset.autoplay === 'true';
      const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!autoplay || reducedMotion || this.slides.length < 2) return;

      this._interval = Number(this.dataset.autoplayInterval) || 5000;
      this._loop = this.dataset.autoplayLoop === 'true';
      this._pauseOnHover = this.dataset.autoplayPauseOnHover === 'true';

      if (this._pauseOnHover) {
        this.addEventListener('mouseenter', this._pauseAutoplay);
        this.addEventListener('mouseleave', this._resumeAutoplay);
        this.addEventListener('focusin', this._pauseAutoplay);
        this.addEventListener('focusout', this._resumeAutoplay);
      }

      this._startAutoplay();
    }

    _startAutoplay() {
      this._stopAutoplay();
      this._timer = setInterval(() => this._advance(), this._interval);
    }

    _stopAutoplay() {
      if (this._timer) clearInterval(this._timer);
      this._timer = null;
    }

    _pauseAutoplay() {
      this._stopAutoplay();
    }

    _resumeAutoplay() {
      if (this._interval) this._startAutoplay();
    }

    _advance() {
      const next = this._currentIndex() + 1;
      if (next >= this.slides.length) {
        if (this._loop) this._showIndex(0);
        else this._stopAutoplay();
        return;
      }
      this._showIndex(next);
    }

    _currentIndex() {
      // Tracks the active slide directly rather than inferring position
      // from scrollLeft — a smooth-scroll animation triggered by the
      // previous showMedia() call may still be in flight, and deriving the
      // index from an in-progress scroll position can desync autoplay from
      // what's actually on screen.
      const index = this.slides.findIndex((s) => s.classList.contains('is-active'));
      return index >= 0 ? index : 0;
    }

    _onThumbClick(event) {
      const mediaId = event.currentTarget.dataset.mediaId;
      this.showMedia(mediaId);
      // A manual pick shouldn't be immediately undone by a rotation that
      // was already partway through its interval.
      if (this._interval) this._startAutoplay();
    }

    _onKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this._showIndex(this._currentIndex() - 1);
        if (this._interval) this._startAutoplay();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this._showIndex(this._currentIndex() + 1);
        if (this._interval) this._startAutoplay();
      }
    }

    _showIndex(index) {
      const clamped = Math.max(0, Math.min(index, this.slides.length - 1));
      const slide = this.slides[clamped];
      if (slide) this.showMedia(slide.dataset.mediaId);
    }

    showMedia(mediaId) {
      const slide = this.slides.find((s) => s.dataset.mediaId === String(mediaId));
      if (slide && this.main) {
        this.main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      this._setActiveMedia(mediaId);
    }

    _onMainScroll() {
      clearTimeout(this._scrollSyncTimer);
      // Waits for the swipe/scroll gesture to settle rather than firing on
      // every scroll event — matches native scroll-snap's own timing and
      // avoids flickering the active thumbnail mid-swipe.
      this._scrollSyncTimer = setTimeout(() => this._syncActiveFromScroll(), 120);
    }

    // Reconciles the active slide/thumbnail from wherever the gallery
    // actually is right now — the single source of truth is scroll
    // position, not which control (if any) last drove it there.
    _syncActiveFromScroll() {
      if (!this.main || this.slides.length === 0) return;
      const scrollLeft = this.main.scrollLeft;
      let nearest = this.slides[0];
      let nearestDistance = Infinity;
      for (const slide of this.slides) {
        const distance = Math.abs(slide.offsetLeft - scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearest = slide;
        }
      }
      this._setActiveMedia(nearest.dataset.mediaId);
    }

    // State-only: updates which slide/thumbnail is marked active without
    // moving the main gallery's scroll position. showMedia() calls this
    // after triggering its own scroll; _syncActiveFromScroll() calls it
    // directly, since the user's own swipe already moved the gallery.
    _setActiveMedia(mediaId) {
      const id = String(mediaId);
      if (id === this._activeMediaId) return;
      this._activeMediaId = id;

      this.slides.forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === id));
      this.thumbs.forEach((thumb) => {
        const isActive = thumb.dataset.mediaId === id;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', String(isActive));
        // Scrolls only the thumbnail strip's own horizontal overflow, never
        // the page. scrollIntoView({block: 'nearest'}) looks like the right
        // tool for this, but it walks every scrollable ancestor on both
        // axes — if the shopper had scrolled away from the gallery (e.g.
        // reading further down the page) while autoplay was still
        // rotating, it would yank the whole page back up to bring the
        // thumbnail back into the vertical viewport. Moving only
        // scrollLeft on the strip itself can't affect page scroll at all.
        if (isActive && this.thumbsStrip) {
          const stripRect = this.thumbsStrip.getBoundingClientRect();
          const thumbRect = thumb.getBoundingClientRect();
          const isOutOfView = thumbRect.left < stripRect.left || thumbRect.right > stripRect.right;
          if (isOutOfView) {
            const target =
              thumb.offsetLeft - this.thumbsStrip.clientWidth / 2 + thumb.clientWidth / 2;
            this.thumbsStrip.scrollTo({ left: target, behavior: 'smooth' });
          }
        }
      });
    }
  }

  if (!customElements.get('ardent-gallery')) {
    customElements.define('ardent-gallery', ArdentGallery);
  }

  class ArdentProduct extends HTMLElement {
    connectedCallback() {
      this.basePrice = parseInt(this.dataset.basePrice || '0', 10);
      this.comparePrice = parseInt(this.dataset.comparePrice || this.dataset.basePrice || '0', 10);
      this.currency = this.dataset.currency;
      this.locale = this.dataset.locale;

      this.quantityInput = this.querySelector('[data-ardent-quantity-input]');
      this.priceEls = this.querySelectorAll('[data-ardent-price]');
      this.compareEls = this.querySelectorAll('[data-ardent-compare]');
      this.savePillEl = this.querySelector('[data-ardent-save-pill]');
      this.addLabelEls = this.querySelectorAll('[data-ardent-add-label]');
      this.addBtns = this.querySelectorAll('[data-ardent-add-btn]');

      this._onTierChange = this._onTierChange.bind(this);
      this.addEventListener('change', this._onTierChange);

      this.querySelectorAll('[data-ardent-tier]').forEach((tier) => this._renderTierPrices(tier));

      this._onSubmit = this._onSubmit.bind(this);
      this.form = this.querySelector('form');
      if (this.form) this.form.addEventListener('submit', this._onSubmit);

      this._onAccordionClick = this._onAccordionClick.bind(this);
      this.querySelectorAll('[data-ardent-accordion-trigger]').forEach((btn) =>
        btn.addEventListener('click', this._onAccordionClick)
      );

      this._onThumbClick = this._onThumbClick.bind(this);
      this.querySelectorAll('[data-ardent-thumb]').forEach((btn) =>
        btn.addEventListener('click', this._onThumbClick)
      );

      // Desktop keeps tasting notes under the gallery in the left column;
      // mobile reads it after the spec grid instead. The two columns have
      // independently-flowing heights (by design, so neither column waits
      // on the other), which is exactly what a single CSS grid with shared
      // row tracks can't reproduce without reintroducing that coupling —
      // so this moves the one real DOM node rather than duplicating it or
      // fighting layout with grid-row placement.
      this._mobileQuery = window.matchMedia('(max-width: 989px)');
      this._onLayoutChange = this._layoutTastingNotes.bind(this);
      this._mobileQuery.addEventListener('change', this._onLayoutChange);
      this._layoutTastingNotes();
    }

    disconnectedCallback() {
      if (this._mobileQuery) this._mobileQuery.removeEventListener('change', this._onLayoutChange);
    }

    _layoutTastingNotes() {
      const tasting = this.querySelector('[data-ardent-tasting]');
      if (!tasting) return;

      if (this._mobileQuery.matches) {
        const specGrid = this.querySelector('.ardent-spec-grid');
        if (specGrid && tasting.previousElementSibling !== specGrid) {
          specGrid.insertAdjacentElement('afterend', tasting);
        }
      } else {
        const mediaCol = this.querySelector('.ardent-product__media-col');
        if (mediaCol && tasting.parentElement !== mediaCol) {
          mediaCol.appendChild(tasting);
        }
      }
    }

    _formatMoney(cents) {
      try {
        return new Intl.NumberFormat(this.locale || undefined, { style: 'currency', currency: this.currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    _renderTierPrices(tier) {
      const quantity = Number(tier.dataset.quantity);
      const discount = Number(tier.dataset.discount);
      const unitPrice = Math.round((this.basePrice * (100 - discount)) / 100);

      const eachEl = tier.querySelector('[data-ardent-tier-each]');
      if (eachEl && quantity > 1) eachEl.textContent = this._formatMoney(unitPrice) + ' each';

      const saveEl = tier.querySelector('[data-ardent-tier-save]');
      if (saveEl && discount > 0) {
        const flagged = tier.classList.contains('ardent-product__tier--flagged');
        saveEl.textContent = 'Save ' + discount + '%' + (flagged ? ' · Best value' : '');
      }
    }

    _onThumbClick(event) {
      const btn = event.currentTarget;
      const img = this.querySelector('.ardent-product__packshot-img');
      if (img && btn.dataset.fullSrc) img.src = btn.dataset.fullSrc;
      this.querySelectorAll('[data-ardent-thumb]').forEach((t) => t.classList.remove('is-active'));
      btn.classList.add('is-active');
    }

    _onAccordionClick(event) {
      const item = event.currentTarget.closest('[data-ardent-accordion-item]');
      const wasOpen = item.classList.contains('is-open');

      this.querySelectorAll('[data-ardent-accordion-item]').forEach((el) => {
        el.classList.remove('is-open');
        el.querySelector('[data-ardent-accordion-trigger]').setAttribute('aria-expanded', 'false');
        el.querySelector('.ardent-product__accordion-panel').hidden = true;
      });

      if (!wasOpen) {
        item.classList.add('is-open');
        item.querySelector('[data-ardent-accordion-trigger]').setAttribute('aria-expanded', 'true');
        item.querySelector('.ardent-product__accordion-panel').hidden = false;
      }
    }

    _onTierChange(event) {
      if (!event.target.matches('[data-ardent-tier] .ardent-product__tier-input')) return;

      const tier = event.target.closest('[data-ardent-tier]');
      const quantity = Number(tier.dataset.quantity);
      const discount = Number(tier.dataset.discount);
      const unitPrice = Math.round((this.basePrice * (100 - discount)) / 100);
      const total = unitPrice * quantity;
      // Baseline is the real compare-at price, not the selling price — a
      // tier discount compounds on top of any existing markdown rather
      // than replacing it, so the shown saving always reflects both.
      const compareTotal = this.comparePrice * quantity;
      const savings = compareTotal - total;

      if (this.quantityInput) this.quantityInput.value = quantity;
      this.priceEls.forEach((el) => {
        el.textContent = this._formatMoney(total);
      });

      this.compareEls.forEach((el) => {
        if (savings > 0) {
          el.hidden = false;
          el.textContent = this._formatMoney(compareTotal);
        } else {
          el.hidden = true;
        }
      });

      if (this.savePillEl) {
        if (savings > 0) {
          this.savePillEl.hidden = false;
          this.savePillEl.textContent = 'Save ' + this._formatMoney(savings);
        } else {
          this.savePillEl.hidden = true;
        }
      }

      this.addLabelEls.forEach((el) => {
  if (el.dataset.soldOut) return;
  const bottleWord = quantity > 1 ? 'Bottles' : 'Bottle';
  let label = 'Add ' + quantity + ' ' + bottleWord + ' To Cart';
  if (savings > 0) label += ' - Save ' + this._formatMoney(savings);
  el.textContent = label;
});
    }

    async _onSubmit(event) {
  event.preventDefault();

  const wrapper = this.querySelector('[data-ardent-submit-wrapper]');
  const labels = this.addLabelEls;
  const errorEl = this.querySelector('[data-ardent-error]');
  const originalTexts = Array.from(labels).map((label) => label.textContent);

  if (errorEl) errorEl.hidden = true;
  this.addBtns.forEach((btn) => {
    btn.disabled = true;
  });
  labels.forEach((label) => {
    label.textContent = wrapper.dataset.addingText;
  });

  try {
    const response = await fetch(this.form.action, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(this.form),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Add to cart failed');

    labels.forEach((label) => {
      label.textContent = wrapper.dataset.addedText;
    });
    this.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { item: data } }));
    setTimeout(() => {
      labels.forEach((label, i) => {
        label.textContent = originalTexts[i];
      });
    }, 1800);
  } catch (error) {
    if (errorEl) {
      errorEl.textContent = error.message;
      errorEl.hidden = false;
    }
    labels.forEach((label, i) => {
      label.textContent = originalTexts[i];
    });
  } finally {
    this.addBtns.forEach((btn) => {
      btn.disabled = false;
    });
  }
 }
}
  if (!customElements.get('ardent-product')) {
    customElements.define('ardent-product', ArdentProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ardent-testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
  class ArdentTestimonialCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]')).map((el) => ({
        quote: el.dataset.quote,
        name: el.dataset.name,
        role: el.dataset.role,
        rating: Number(el.dataset.rating) || 0,
      }));
      if (this.slides.length === 0) return;

      this.index = 0;
      this.quoteEl = this.querySelector('[data-carousel-quote]');
      this.ratingEl = this.querySelector('[data-carousel-rating]');
      this.nameEl = this.querySelector('[data-carousel-name]');
      this.roleEl = this.querySelector('[data-carousel-role]');
      this.counterEl = this.querySelector('[data-carousel-counter]');
      this.prevBtn = this.querySelector('[data-carousel-prev]');
      this.nextBtn = this.querySelector('[data-carousel-next]');

      if (this.slides.length < 2) {
        // A single testimonial still needs its quote/name/role/rating
        // painted — only the prev/next navigation is irrelevant here.
        if (this.prevBtn) this.prevBtn.hidden = true;
        if (this.nextBtn) this.nextBtn.hidden = true;
        this._render();
        return;
      }

      this.prevBtn?.addEventListener('click', () => this._go(this.index - 1));
      this.nextBtn?.addEventListener('click', () => this._go(this.index + 1));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this._go(this.index - 1);
        if (event.key === 'ArrowRight') this._go(this.index + 1);
      });

      this._render();
    }

    _go(next) {
      const total = this.slides.length;
      this.index = ((next % total) + total) % total;
      this._render();
    }

    _trim(text, max) {
      return text.length > max ? text.slice(0, max) + '…' : text;
    }

    _pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    _renderCounter() {
      if (!this.counterEl) return;
      this.counterEl.textContent =
        this.slides.length > 1 ? `${this._pad(this.index + 1)} / ${this._pad(this.slides.length)}` : '';
    }

    _render() {
      const total = this.slides.length;
      const current = this.slides[this.index];

      if (this.quoteEl) this.quoteEl.textContent = `“${current.quote}”`;
      if (this.nameEl) this.nameEl.textContent = current.name || '';
      if (this.roleEl) this.roleEl.textContent = current.role || '';
      this._renderCounter();

      if (this.ratingEl) {
        this.ratingEl.hidden = current.rating === 0;
        this.ratingEl.style.setProperty('--rating-percent', `${(current.rating / 5) * 100}%`);
      }

      const prev = this.slides[(this.index - 1 + total) % total];
      const next = this.slides[(this.index + 1) % total];
      if (this.prevBtn) this.prevBtn.textContent = `“${this._trim(prev.quote, 46)}`;
      if (this.nextBtn) this.nextBtn.textContent = `${this._trim(next.quote, 46)}”`;
    }
  }

  if (!customElements.get('ardent-testimonial-carousel')) {
    customElements.define('ardent-testimonial-carousel', ArdentTestimonialCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class DispatchCountdown extends HTMLElement {
    connectedCallback() {
      this.targetMs = Number(this.dataset.targetEpoch) * 1000;
      this.template = this.dataset.countdownTemplate;
      this.afterMessage = this.dataset.afterMessage;
      if (!this.targetMs || !this.template) return;

      this._tick = this._tick.bind(this);
      this._onVisibility = this._onVisibility.bind(this);
      document.addEventListener('visibilitychange', this._onVisibility);
      this._start();
    }

    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this._onVisibility);
      this._stop();
    }

    _onVisibility() {
      if (document.hidden) this._stop();
      else this._start();
    }

    _start() {
      if (this._timer || document.hidden) return;
      this._tick();
      this._timer = setInterval(this._tick, 1000);
    }

    _stop() {
      if (this._timer) clearInterval(this._timer);
      this._timer = null;
    }

    _tick() {
      const remaining = this.targetMs - Date.now();
      if (remaining <= 0) {
        this._stop();
        if (this.afterMessage) this.textContent = this.afterMessage;
        return;
      }
      const totalSeconds = Math.floor(remaining / 1000);
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;
      const pad = (n) => String(n).padStart(2, '0');
      // Drop the leading "00:" hours segment once under an hour remains —
      // "05:00" counting down reads far better than "00:05:00" full of
      // dead zeros. The threshold setting caps this countdown at 8 hours
      // max, so hours only ever shows as a single low digit anyway.
      const display = h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
      this.textContent = this.template.replace('__TIME__', display);
    }
  }

  if (!customElements.get('dispatch-countdown')) {
    customElements.define('dispatch-countdown', DispatchCountdown);
  }

  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error('Cart recommendations request failed');
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.querySelector('[data-cart-recommendations-list]');
          if (!content) return;
          this.innerHTML = content.innerHTML;
        })
        .catch(() => {
          this.hidden = true;
        });
    }
  }

  if (!customElements.get('cart-recommendations')) {
    customElements.define('cart-recommendations', CartRecommendations);
  }

  class CartDrawerContent extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      this._onChange = this._onChange.bind(this);
      this._onCartAdd = this._onCartAdd.bind(this);

      this.addEventListener('click', this._onClick);
      this.addEventListener('change', this._onChange);
      document.addEventListener('cart:add', this._onCartAdd);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:add', this._onCartAdd);
    }

    _onCartAdd() {
      const drawer = this.closest('theme-drawer');
      this.refresh().then(() => {
        if (drawer && typeof drawer.open === 'function') drawer.open();
      });
    }

    _onClick(event) {
      const continueShopping = event.target.closest('[data-cart-continue-shopping]');
      if (continueShopping) {
        // No merchant URL configured — "continue shopping" means staying
        // right where the shopper already was, so this just closes the
        // drawer rather than navigating anywhere.
        const drawer = this.closest('theme-drawer');
        if (drawer && typeof drawer.close === 'function') drawer.close();
        return;
      }

      const decrease = event.target.closest('[data-quantity-decrease]');
      const increase = event.target.closest('[data-quantity-increase]');
      const remove = event.target.closest('[data-cart-remove]');

      if (decrease || increase) {
        const wrapper = event.target.closest('[data-cart-line]');
        const input = wrapper.querySelector('[data-cart-quantity-input]');
        const current = Number(input.value) || 0;
        const next = decrease ? Math.max(0, current - 1) : current + 1;
        this._updateLine(wrapper, next);
      }

      if (remove) {
        const wrapper = event.target.closest('[data-cart-line]');
        this._updateLine(wrapper, 0);
      }
    }

    _onChange(event) {
      const input = event.target.closest('[data-cart-quantity-input]');
      if (!input) return;
      const wrapper = input.closest('[data-cart-line]');
      this._updateLine(wrapper, Number(input.value) || 0);
    }

    async _updateLine(wrapper, quantity) {
      const line = wrapper.dataset.cartLine;
      const errorEl = wrapper.querySelector('[data-cart-line-error]');
      wrapper.setAttribute('data-line-loading', '');
      if (errorEl) errorEl.hidden = true;

      try {
        const response = await fetch(this.dataset.cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity }),
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Cart update failed');
        }
        await this.refresh();
      } catch (error) {
        wrapper.removeAttribute('data-line-loading');
        if (errorEl) {
          errorEl.textContent = error.message;
          errorEl.hidden = false;
        }
      }
    }

    async refresh() {
      this.setAttribute('aria-busy', 'true');
      try {
        // Deliberately NOT the cart AJAX `sections=` parameter here: for a
        // section instance that lives in footer-group.json, that endpoint
        // reliably falls back to schema defaults instead of the real
        // configured settings (verified directly on the live storefront —
        // dispatch message, trust row and the recommendations heading all
        // silently reverted after the first quantity change). A normal
        // fetch of the current page renders through the same path a real
        // browser navigation does, which resolves every setting correctly,
        // so that's what this refreshes from instead. Heavier than a
        // section-fragment fetch, but correctness matters more here than
        // the extra payload size.
        const response = await fetch(location.pathname + location.search);
        if (!response.ok) throw new Error('Cart refresh failed');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-drawer-content]');
        if (!fresh) return;

        this.innerHTML = fresh.innerHTML;

        const itemCount = fresh.getAttribute('data-cart-item-count');
        if (itemCount !== null) {
          this.setAttribute('data-cart-item-count', itemCount);

          const headerCount = document.querySelector('[data-cart-count]');
          if (headerCount) {
            headerCount.textContent = itemCount;
            headerCount.hidden = itemCount === '0';
          }

          // Read the freshly server-rendered title text straight from the
          // fetched page rather than reconstructing "N items"/"1 item"/
          // "empty" phrasing here — that logic already lives once, in the
          // Liquid that rendered this same response.
          const titleEl = this.closest('theme-drawer')?.querySelector('.drawer__title');
          const freshTitleEl = doc.querySelector('#cart-drawer .drawer__title');
          if (titleEl && freshTitleEl) {
            titleEl.textContent = freshTitleEl.textContent;
          }
        }
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('cart-drawer-content')) {
    customElements.define('cart-drawer-content', CartDrawerContent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complete-collection"] && !Shopify.designMode) return;
  try {
    
  class CompleteCollection extends HTMLElement {
    connectedCallback() {
      this.addAllButton = this.querySelector('[data-complete-collection-add-all] .button');
      if (!this.addAllButton) return;

      this._defaultLabel = this.addAllButton.querySelector('.button__label')?.textContent || '';
      this._onAddAll = this._onAddAll.bind(this);
      this.addAllButton.addEventListener('click', this._onAddAll);
    }

    disconnectedCallback() {
      if (this.addAllButton) this.addAllButton.removeEventListener('click', this._onAddAll);
    }

    async _onAddAll() {
      const url = this.dataset.cartAddUrl;
      const items = [...this.querySelectorAll('[data-complete-collection-item]')]
        .map((el) => el.dataset.variantId)
        .filter(Boolean)
        .map((id) => ({ id, quantity: 1 }));

      if (!url || items.length === 0) return;

      const label = this.addAllButton.querySelector('.button__label');
      this.addAllButton.disabled = true;
      if (label) label.textContent = this.addAllButton.dataset.addingText || this._defaultLabel;

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) throw new Error('Add all failed');

        this.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items } }));
      } finally {
        this.addAllButton.disabled = false;
        if (label) label.textContent = this._defaultLabel;
      }
    }
  }

  if (!customElements.get('complete-collection')) {
    customElements.define('complete-collection', CompleteCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class ThemeHeader extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-transparent') && !this.hasAttribute('data-compact-on-scroll')) return;

      this._onScroll = this._onScroll.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this._onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
    }

    _onScroll() {
      if (this.hasAttribute('data-transparent')) {
        this.classList.toggle('is-scrolled', window.scrollY > 10);
      }
      if (this.hasAttribute('data-compact-on-scroll')) {
        this.classList.toggle('is-compact', window.scrollY > 50);
      }
    }
  }

  if (!customElements.get('theme-header')) {
    customElements.define('theme-header', ThemeHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-gallery-main]');
      this.thumbs = [...this.querySelectorAll('[data-gallery-thumbs] [data-media-id]')];

      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    _onClick(event) {
      const thumb = event.target.closest('[data-gallery-thumbs] [data-media-id]');
      if (thumb) this.showMedia(thumb.dataset.mediaId);
    }

    showMedia(mediaId) {
      const slide = this.main && this.main.querySelector(`[data-media-id="${mediaId}"]`);
      if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });

      this.thumbs.forEach((thumb) => {
        if (thumb.dataset.mediaId === String(mediaId)) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  class ProductInfo extends HTMLElement {
    connectedCallback() {
      this._onVariantChange = this._onVariantChange.bind(this);
      this.addEventListener('variant:change', this._onVariantChange);
    }

    disconnectedCallback() {
      this.removeEventListener('variant:change', this._onVariantChange);
    }

    _onVariantChange(event) {
      const { variant } = event.detail;
      if (!variant) return;

      const priceEl = this.querySelector('[data-price]');
      if (priceEl) priceEl.textContent = variant.price;

      const compareEl = this.querySelector('[data-compare-price]');
      if (compareEl) {
        const strike = compareEl.querySelector('s');
        if (strike) strike.textContent = variant.compare_at_price;
        compareEl.hidden = !variant.on_sale;
      }

      const badgeEl = this.querySelector('[data-sale-badge]');
      if (badgeEl) badgeEl.hidden = !variant.on_sale;

      const savingEl = this.querySelector('[data-saving-percent]');
      if (savingEl) {
        savingEl.textContent = variant.saving_text;
        savingEl.hidden = !variant.on_sale;
      }

      const idInput = this.querySelector('[data-buy-buttons-variant-id]');
      if (idInput) idInput.value = variant.id;

      const submitWrapper = this.querySelector('[data-buy-buttons-submit]');
      if (submitWrapper) {
        const button = submitWrapper.querySelector('.button');
        const label = submitWrapper.querySelector('.button__label');
        if (label) {
          label.textContent = variant.available
            ? submitWrapper.dataset.addToCartText
            : submitWrapper.dataset.soldOutText;
        }
        if (button) button.toggleAttribute('disabled', !variant.available);
      }

      const paymentWrapper = this.querySelector('[data-buy-buttons-payment]');
      if (paymentWrapper) paymentWrapper.hidden = !variant.available;

      const stockEl = this.querySelector('[data-stock-level]');
      if (stockEl) {
        const threshold = Number(stockEl.dataset.threshold) || 0;
        const quantity = variant.inventory_quantity || 0;
        const show = variant.inventory_tracked && threshold > 0 && quantity > 0 && quantity <= threshold;

        stockEl.hidden = !show;

        if (show) {
          const textEl = stockEl.querySelector('[data-stock-text]');
          if (textEl) textEl.textContent = variant.stock_text;

          const barEl = stockEl.querySelector('[data-stock-bar]');
          if (barEl) barEl.style.width = `${Math.min(100, (quantity / threshold) * 100)}%`;
        }
      }

      const gallery = this.querySelector('product-gallery');
      if (gallery && typeof gallery.showMedia === 'function' && variant.featured_media_id) {
        gallery.showMedia(variant.featured_media_id);
      }
    }
  }

  if (!customElements.get('product-info')) {
    customElements.define('product-info', ProductInfo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      const target = Date.parse(this.dataset.target);
      if (Number.isNaN(target)) return;

      this.target = target;
      this.days = this.querySelector('[data-countdown-days]');
      this.hours = this.querySelector('[data-countdown-hours]');
      this.minutes = this.querySelector('[data-countdown-minutes]');
      this.seconds = this.querySelector('[data-countdown-seconds]');

      const targetLabel = this.querySelector('[data-countdown-target]');
      if (targetLabel) {
        targetLabel.textContent = new Date(target).toLocaleString(document.documentElement.lang || undefined, {
          dateStyle: 'long',
          timeStyle: 'short',
        });
      }

      this._tick();
      this._timer = setInterval(() => this._tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this._timer);
    }

    _tick() {
      const remaining = this.target - Date.now();
      if (remaining <= 0) {
        clearInterval(this._timer);
        this.hidden = true;
        return;
      }

      this.hidden = false;
      const totalSeconds = Math.floor(remaining / 1000);
      const pad = (value) => String(value).padStart(2, '0');

      this.days.textContent = pad(Math.floor(totalSeconds / 86400));
      this.hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      this.minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      this.seconds.textContent = pad(totalSeconds % 60);
    }
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class SlideShow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.slideshow__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'));
      if (this.slides.length < 2) return;

      this.index = 0;
      this.slides[0].classList.add('is-active');
      if (this.dots[0]) this.dots[0].classList.add('is-active');

      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);

      if (this.dataset.autoplay === 'true') {
        this.interval = Number(this.dataset.interval) || 6000;
        this._timer = setInterval(() => this._go(this.index + 1), this.interval);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      clearInterval(this._timer);
    }

    _onClick(event) {
      if (event.target.closest('[data-slide-prev]')) this._go(this.index - 1);
      if (event.target.closest('[data-slide-next]')) this._go(this.index + 1);
      const dot = event.target.closest('[data-slide-dot]');
      if (dot) this._go(Number(dot.dataset.slideDot));
    }

    _go(next) {
      const total = this.slides.length;
      const nextIndex = ((next % total) + total) % total;
      this.slides[this.index].classList.remove('is-active');
      if (this.dots[this.index]) this.dots[this.index].classList.remove('is-active');
      this.index = nextIndex;
      this.slides[this.index].classList.add('is-active');
      if (this.dots[this.index]) this.dots[this.index].classList.add('is-active');
    }
  }

  if (!customElements.get('slide-show')) {
    customElements.define('slide-show', SlideShow);
  }

  } catch(e) { console.error(e); }
})();
})();
